<template>
    <b-container v-resize="onResize" v-bind:style="{height:treeHeight+'px'}" style="overflow: auto;">
        <b-navbar toggleable type="light" variant="light" sticky>
            <div>
                <b-button variant="outline-primary" size="sm" @click="saveList86" class="mx-2">Save</b-button>
                <b-button variant="outline-danger" size="sm" @click="resetList86" class="mx-2">Reset</b-button>                        
            </div>
            <b-nav-form>
                <b-form-input size="sm" class="mr-sm-2" v-model="searchQuery" placeholder="Search"></b-form-input>
            </b-nav-form>
        </b-navbar>
        <b-table-simple bordered hover small responsive >
            <b-thead head-variant="none">                            
                <b-tr>
                    <b-th>Name</b-th>
                    <b-th>Type</b-th>
                    <b-th>Status</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item) in filterList86" :key="item.date">
                    <b-td>{{item.name}}</b-td>
                    <b-td>{{item.isItem ? 'Item' : 'Option' }}</b-td>
                    <b-td>
                        <b-form-select
                            size="sm"
                            v-if="renderComponent"
                            @change="setSelectOption($event, item)"
                            :value="getSelectOption(item)"
                            :options="availableOptions"
                        />
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </b-container>
</template>

<script>
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
    name : 'List86',
    components:{  },
    props : [],
    data() { 
        return { 
            searchQuery : '',
            renderComponent: true,
            treeHeight : 0,
            list86:[],
            availableOptions:["Available", "Today", "Forever"]
        } 
    },
    computed : {
        ...mapState({
            userInfo : "userInfo",
            selectedLocation : "selectedLocation"
        }),
        filterList86(){
            return this.list86.filter(item => {
                return this.searchQuery ? item.name.indexOf(this.searchQuery.trim()) !== -1 : true
            });
        }
    },
    watch : {
        selectedLocation: {
            deep: true,
            immediate: true,
            handler() {
                this.getList86();
            }
        }
    },
    created() { 
    },
    destroyed() { },
    methods: { 
        forceRerender() {
            this.renderComponent = false;
            this.$nextTick(() => {
                this.renderComponent = true;
            });
        },
        onResize() {
            let navheader = document.getElementById('navheader')            
            if(navheader){
                this.treeHeight = window.innerHeight - navheader.offsetHeight - 10;
            }
        },
        getList86(){
            this.$store.dispatch('apiGetList86')
                    .then(({status, res}) => {
                            if(status){
                                this.list86 = res;
                            }
                        })
                    .catch(e=>{ console.log("apiGetList86-E", e) })
        },
        getSelectOption(option) {
            let selection = 0;
            if (!option.unavailable) {
                selection = 0;
            } else if (option.unavailable) {
                if (option.unavailableForDay == null) {
                    selection = 2;
                } else {
                    let sameDate;
                    try {
                        let tz = (this.userInfo.location.timeZone).trim();
                        let tzTime = this.moment().tz(tz);                         
                        sameDate = this.moment(option.unavailableForDay).utc().format("L") === this.moment(tzTime).format("L");
                    } catch (E) {
                        console.error(E)
                        sameDate = false;
                    }
                    if (sameDate) {
                        selection = 1;
                    } else {
                        selection = 0;
                        // option.unavailable = false;
                    }
                }
            }                       
            return this.availableOptions[selection];
        },
        setSelectOption(status, option) {
            if (status === this.availableOptions[0]) {
                option.unavailable = false;
                option.unavailableForDay = null;//0
            }
            if (status === this.availableOptions[1]) {
                let tzTime = this.moment();
                try {
                    tzTime = this.moment().tz((this.userInfo.location.timeZone).trim());                         
                } catch (E) {
                    console.log("TimeZone", E);
                }
                option.unavailable = true;
                option.unavailableForDay = tzTime.format("YYYY-MM-DD");
            }
            if (status === this.availableOptions[2]) {
                option.unavailable = true;
                option.unavailableForDay = null;//2
            }   
            // console.log(status, option)
        },
        saveList86(){
            this.$store.dispatch('apiUpdateList86', this.filterList86)
                    .then(({status}) => {
                            if(status){
                                Swal.fire('Updated', 'Lis86 has been updated.','success')
                            }
                        })
                    .catch(e=>{ console.log("apiUpdateList86-E", e) })            
        },
        resetList86(){
            this.list86.forEach((item) => {
                item.unavailable = false;
                item.unavailableForDay = null;//0
            })
            this.saveList86();
            this.forceRerender();
        }        
    },
}
</script>
<style scoped lang="scss">

</style>